var e=Symbol.for("ChartLegendShower"),r=Symbol.for("ChartLegendFeature");export{e as I,r as a};
